/* eslint-disable no-nested-ternary */
/* eslint-disable import/prefer-default-export */
import { format } from 'date-fns';
import common from '../_common/common_sales';

const datasetParams = {
  mainFile: 'SalesBySOR/Outputs/s_data/SalesBySOR_s_data.csv',
  runDetailsFile: 'SalesBySOR/Outputs/s_data/SalesBySOR_s_data_runDetails.csv',
  tableName: 'SalesBySOR_s',
  mainDateField: 'Date',
  headersRemaps: {
    Items_Sold: 'SalesUnits',
    Items_Sold_AllParks: 'SalesUnits_AllParks',
    Revenue: 'SalesRevenues',
    Raw_Revenue: 'SalesRevenues_Raw',
  },
  valuesRemaps: {
    ProductType: {
      'MDT/MPT': 'MDT',
    },
    Flag_HOS: {
      0: '0',
      1: '1',
    },
    // SOR: {
    //   'Drive & Overnight': 'D&O',
    // },
  },
  calculatedMetrics: common.sales_calculatedMetrics,
  metrics: common.sales_metrics,
  transformRow: (row) => ({
    ...row,
    // Date: format(new Date(row.Date), 'yyyy-MM-dd'),
    Year: format(new Date(row.Date), 'yyyy'),
    YearMonth: format(new Date(row.Date), 'yyyy-MM'),
    ProductCategory: ['SDT', 'MDT'].includes(row.ProductType) ? 'Discrete' : ['FC', 'Fun Card', 'Pass'].includes(row.ProductType) ? 'Pass' : 'Free',
  }),
  filterDimensions: {
    ...common.sales_filterDimensions,
    State: {
      order: 'desc',
    },
    SOR: {
      order: 'desc',
      customOrder: ['Local', 'Same Day', 'Drive & Overnight', 'Domestic', 'International'],
    },
    Flag_HOS: {
      order: 'asc',
    },
  },
};

export default datasetParams;
